// CloseConfirmModal.jsx
import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import CloudStorage from "../../CloudStorage/CloudStorage";

export default function CloseConfirmModal({ type = 'Add', closeModal, changesIsThere }) {
  const title = type == "Add" ? "Are you sure you want to discard this product addition?" : "You have unsaved changes. Are you sure you want to cancel?";
  const message = "Are you sure you want to Discard?";
  const confirmText = type == "Add" ? "Yes, Discard" : "Yes";
  const cancelText = "Cancel";

  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  const handleConfirm = () => {
    closeModal();
    toggle();

  };

  const handleCancel = () => {
    // onCancel();
    toggle();
  };

  useEffect(() => {
    // document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);


  return (
    <>
      <button onClick={() => { changesIsThere ? toggle() : closeModal() }} className="btn close-modal-btn">
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/close-icon.svg`}
          alt="Close"
        />
      </button>
      <Modal
        className="popupmodal confirm-modal"
        isOpen={isOpen}
        toggle={toggle}
        centered
      >
        <div className="modal-content-wrapper">
          <button onClick={toggle} className="btn close-button">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
              alt="close"
            />
          </button>

          <ModalBody>
            <h4 className="text-center">{title}</h4>
            {/* <p>{message}</p> */}
          </ModalBody>

          <div className="modal-footer d-flex justify-content-end modal-footer-sec">


            <button
              className="btn no"
              style={{
                background: "#fff",
                color: "#000",
                border: "1px solid #000",
              }}
              onClick={handleCancel}
            >
              {cancelText}
            </button>
            <button className="btn yes" onClick={handleConfirm}>
              {confirmText}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}
